import determineGlobalStoreFoffsEnabled from "../../../../../constants/feature-flags";

// Cart Reviews API path constants
export var CART_REVIEWS_V2 = 'cart_reviews/v2';
export var PARTNER_CART_REVIEWS_V2 = 'partner_cart_reviews/v2';
export var PARTNER_CART_REVIEWS_V1 = 'partner_cart_reviews/v1';

/**
 * Determines which version of cart reviews or partner cart reviews to use
 * based on the global store configuration and feature flags
 *
 * @param {object} params - named parameters
 * @param {boolean|undefined} params.isGlobalStoreCountry - Whether the current country is a global store country
 * @returns {string} The path version string (CART_REVIEWS_V2, PARTNER_CART_REVIEWS_V2, or PARTNER_CART_REVIEWS_V1)
 *
 * @description
 * Logic breakdown:
 * - If isGlobalStoreCountry is false (on-platform), returns CART_REVIEWS_V2
 * - If isGlobalStoreCountry is true and foffs feature flag is enabled, returns PARTNER_CART_REVIEWS_V2
 * - If isGlobalStoreCountry is true and foffs feature flag is disabled, returns PARTNER_CART_REVIEWS_V1
 * - If isGlobalStoreCountry is undefined/null, falls back to feature flag determination
 *
 * @example
 * // On-platform country (e.g., US)
 * const path = determineCartReviewsVersion({ isGlobalStoreCountry: false });
 * // Returns: CART_REVIEWS_V2 ('cart_reviews/v2')
 *
 * @example
 * // Global store country with foffs enabled (e.g., Mexico)
 * const path = determineCartReviewsVersion({ isGlobalStoreCountry: true });
 * // Returns: PARTNER_CART_REVIEWS_V2 ('partner_cart_reviews/v2')
 *
 * @example
 * // Global store country with foffs disabled
 * const path = determineCartReviewsVersion({ isGlobalStoreCountry: true });
 * // Returns: PARTNER_CART_REVIEWS_V1 ('partner_cart_reviews/v1')
 */
var determineCartReviewsVersion = function determineCartReviewsVersion(_ref) {
  var isGlobalStoreCountry = _ref.isGlobalStoreCountry;
  // Determine if we should use v2 cart reviews (either on-platform or partner with feature flag)
  var isGlobalStoreFoffsEnabled = determineGlobalStoreFoffsEnabled();
  if (isGlobalStoreCountry === false) {
    return CART_REVIEWS_V2;
  } else if (isGlobalStoreFoffsEnabled === true) {
    return PARTNER_CART_REVIEWS_V2;
  } else {
    return PARTNER_CART_REVIEWS_V1;
  }
};
export default determineCartReviewsVersion;